/**
 * Form'da henüz madde seçilmediğinde gösterilen empty state.
 */
function EmptyState() {
  return (
    <div
      style={{
        height: '200px',
        border: '2px dashed #d9d9d9',
        borderRadius: '6px',
      }}
      className="gx-w-100 gx-align-items-center gx-justify-content-center gx-d-flex"
    >
      Seçilmiş madde bulunmamaktadır.
    </div>
  );
}

export default EmptyState;
